import ROUTES from "../../../router/constants/routes";

export const TMP_DISABLE_MATERIALS_CC = true;

export enum ProposalCreationPanes {
  POS = "select-pos",
  PRODUCTS = "select-products",
  CC = "commercial-conditions",
  RECAP = "recap-fields",
}

export const PANE_INDEX: Record<ProposalCreationPanes, number> = {
  [ProposalCreationPanes.POS]: 0,
  [ProposalCreationPanes.PRODUCTS]: 1,
  [ProposalCreationPanes.CC]: 2,
  [ProposalCreationPanes.RECAP]: 3,
};

export const PANE_INDEX_REV: Record<number, ProposalCreationPanes> = {
  [PANE_INDEX[ProposalCreationPanes.POS]]: ProposalCreationPanes.POS,
  [PANE_INDEX[ProposalCreationPanes.PRODUCTS]]: ProposalCreationPanes.PRODUCTS,
  [PANE_INDEX[ProposalCreationPanes.CC]]: ProposalCreationPanes.CC,
  [PANE_INDEX[ProposalCreationPanes.RECAP]]: ProposalCreationPanes.RECAP,
};

export const ROUTE_TO_PANE = {
  [ROUTES.SELECT_POS]: ProposalCreationPanes.POS,
  [ROUTES.RECOMMENDED_ASSORTMENT]: ProposalCreationPanes.PRODUCTS,
  [ROUTES.COMMERCIAL_PROPOSAL]: ProposalCreationPanes.CC,
  [ROUTES.RECAP]: ProposalCreationPanes.RECAP,
};

export const PANE_PATHS = {
  [ProposalCreationPanes.POS]: ROUTES.SELECT_POS,
  [ProposalCreationPanes.PRODUCTS]: ROUTES.RECOMMENDED_ASSORTMENT,
  [ProposalCreationPanes.CC]: ROUTES.COMMERCIAL_PROPOSAL,
  [ProposalCreationPanes.RECAP]: ROUTES.RECAP,
};

export const PANE_BACK_PATHS = {
  [ProposalCreationPanes.POS]: undefined,
  [ProposalCreationPanes.PRODUCTS]: ROUTES.SELECT_POS,
  [ProposalCreationPanes.CC]: ROUTES.RECOMMENDED_ASSORTMENT,
  [ProposalCreationPanes.RECAP]: ROUTES.COMMERCIAL_PROPOSAL,
};
